import { NgModule } from '@angular/core';
import { AppsSharedModule, BaseSharedModule } from 'base';
import { BaseCustomerEmployeeMasterDataTabComponent } from './_components/employee-master-data-tab/base-customer-employee-master-data-tab.component';
import { BaseCustomerEmployeeOperationInfoTabComponent } from './_components/employee-operation-info-tab/base-customer-employee-operation-info-tab.component';
import { BaseCustomerEmployeeReviewsTabComponent } from './_components/employee-reviews-tab/base-customer-employee-reviews-tab.component';
import { BaseCustomerEmployeeTimeRecordingsTabComponent } from './_components/employee-time-recordings-tab/base-customer-employee-time-recordings-tab.component';
import { BaseCustomerEmployeeTimeRecordingsListItemComponent } from './_components/employee-time-recordings-tab/employee-time-recordings-list-item/base-customer-employee-time-recordings-list-item.component';
import { BaseCustomerShiftReadinessComponent } from './_components/shift-readiness/base-customer-shift-readiness.component';
import { BaseCustomerStaffRequestModalComponent } from './_components/staff-request-modal/base-customer-staff-request-modal.component';
import { BaseCustomerCandidateDocumentComponent } from './_components/employee-documents-tab/base-customer-candidate-document/base-customer-candidate-document.component';
import { BaseCustomerEmployeeDocumentsTabComponent } from './_components/employee-documents-tab/base-customer-employee-documents-tab.component';
import { BaseCustomerEmployeeWorkCouncilTabComponent } from './_components/employee-work-council-tab/base-customer-employee-work-council-tab.component';
import { BaseCustomerChangeStatusConfirmationModalComponent } from './_components/employee-work-council-tab/change-status-confirmation-modal/base-customer-change-status-confirmation-modal.component';
import { BaseCustomerWorkCouncilCommentsComponent } from './_components/employee-work-council-tab/work-council-comments/base-customer-work-council-comments.component';
import { BaseCustomerWorkCouncilCommentComponent } from './_components/employee-work-council-tab/work-council-comment/base-customer-work-council-comment.component';
import { BaseCustomerWorkCouncilStatusButtonsComponent } from './_components/employee-work-council-tab/work-council-offer-status-buttons/base-customer-work-council-status-buttons.component';
import { BaseCustomerEditShiftTimesModalComponent } from './_components/edit-shift-times-modal/base-customer-edit-shift-times-modal.component';
import { BaseCustomerWeekdaysAndShiftsComponent } from './_components/weekdays-and-shifts/base-customer-weekdays-and-shifts.component';
import { BaseCustomerIZSWidgetComponent } from './_components/izs-widget/izs-widget.component';
import { BaseCustomerServiceProviderSelectModalComponent } from './_components/service-provider-select-modal/base-customer-service-provider-select-modal.component';
import { BaseCustomerPublishConfirmationModalComponent } from './_components/service-provider-select-modal/confirmation-modal/base-customer-publish-confirmation-modal.component';
import { BaseCustomerEmployeeReviewItemComponent } from './_components/employee-review-item/base-customer-employee-review-item.component';
import { BaseCustomerInquiryDocumentComponent } from './_components/inquiry-document/base-customer-inquiry-document.component';
import { BaseCustomerRejectOfferModalComponent } from './_components/reject-offer-modal/base-customer-reject-offer-modal.component';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule],
  declarations: [
    BaseCustomerStaffRequestModalComponent,
    BaseCustomerShiftReadinessComponent,
    BaseCustomerEmployeeMasterDataTabComponent,
    BaseCustomerEmployeeOperationInfoTabComponent,
    BaseCustomerEmployeeReviewsTabComponent,
    BaseCustomerEmployeeTimeRecordingsTabComponent,
    BaseCustomerEmployeeTimeRecordingsListItemComponent,
    BaseCustomerCandidateDocumentComponent,
    BaseCustomerEmployeeDocumentsTabComponent,
    BaseCustomerEmployeeWorkCouncilTabComponent,
    BaseCustomerChangeStatusConfirmationModalComponent,
    BaseCustomerWorkCouncilCommentsComponent,
    BaseCustomerWorkCouncilCommentComponent,
    BaseCustomerWorkCouncilStatusButtonsComponent,
    BaseCustomerEditShiftTimesModalComponent,
    BaseCustomerWeekdaysAndShiftsComponent,
    BaseCustomerIZSWidgetComponent,
    BaseCustomerServiceProviderSelectModalComponent,
    BaseCustomerPublishConfirmationModalComponent,
    BaseCustomerEmployeeReviewItemComponent,
    BaseCustomerInquiryDocumentComponent,
    BaseCustomerRejectOfferModalComponent,
  ],
  exports: [
    BaseCustomerStaffRequestModalComponent,
    BaseCustomerShiftReadinessComponent,
    BaseCustomerEmployeeMasterDataTabComponent,
    BaseCustomerEmployeeOperationInfoTabComponent,
    BaseCustomerEmployeeReviewsTabComponent,
    BaseCustomerEmployeeTimeRecordingsTabComponent,
    BaseCustomerEmployeeTimeRecordingsListItemComponent,
    BaseCustomerCandidateDocumentComponent,
    BaseCustomerEmployeeDocumentsTabComponent,
    BaseCustomerEmployeeWorkCouncilTabComponent,
    BaseCustomerChangeStatusConfirmationModalComponent,
    BaseCustomerWorkCouncilCommentsComponent,
    BaseCustomerWorkCouncilCommentComponent,
    BaseCustomerWorkCouncilStatusButtonsComponent,
    BaseCustomerEditShiftTimesModalComponent,
    BaseCustomerWeekdaysAndShiftsComponent,
    BaseCustomerIZSWidgetComponent,
    BaseCustomerServiceProviderSelectModalComponent,
    BaseCustomerPublishConfirmationModalComponent,
    BaseCustomerEmployeeReviewItemComponent,
    BaseCustomerInquiryDocumentComponent,
    BaseCustomerRejectOfferModalComponent,
  ],
})
export class BaseCustomerSharedModule {}
